export const descriptionElement = {
  addNewDescriptionElement: "Neues Beschreibungselement hinzufügen",
  selectNoteFromListOr: "Notiz aus Liste auswählen oder",
  createNew: "neu erstellen"
};
